import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import UpdateModal from './UpdateModal';

const Updates = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    // State Variables
    const [updates, setUpdates] = useState([
        { image: 'image1.jpg', headline: 'Update 1', description: 'Description of update 1', url: 'https://example.com', teamUser: 'Team A', active: true },
        { image: 'image2.jpg', headline: 'Update 2', description: 'Description of update 2', url: 'https://example.com', teamUser: 'Team B', active: false },
        { image: 'image3.jpg', headline: 'Update 3', description: 'Description of update 3', url: 'https://example.com', teamUser: 'User C', active: true },
    ]);

    // Pagination State
    const [filteredPlans, setFilteredPlans] = useState(updates);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredPlans.length / itemsPerPage);


    useEffect(() => {
        const filtered = updates.filter((update) => 
            Object.values(update).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredPlans(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, updates]);
    

    // Toggle Active Status
    const toggleActive = (index) => {
        const updatedUpdates = [...updates];
        updatedUpdates[index].active = !updatedUpdates[index].active;
        setUpdates(updatedUpdates);
    };

    const handleSearch = (e) => setSearchQuery(e.target.value);
    // Delete an Update
    const handleDelete = (index) => {
        const currentData = updates.filter((_, i) => i !== index);
        setUpdates(currentData);
    };

    // Pagination Handler
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Get Current Updates
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentUpdates = filteredPlans.slice(startIndex, startIndex + itemsPerPage);

    return (
        <>
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Updates</h1>

                    {/* Add Updates Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add updates
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Updates Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Headline</th>
                                <th>Description</th>
                                <th>URL</th>
                                <th>Team/User</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUpdates.length > 0 ? (
                                currentUpdates.map((update, index) => (
                                    <tr key={index}>
                                        <td><img src={update.image} alt={update.headline} width="50" height="50" /></td>
                                        <td>{update.headline}</td>
                                        <td>{update.description}</td>
                                        <td><a href={update.url} target="_blank" rel="noopener noreferrer">{update.url}</a></td>
                                        <td>{update.teamUser}</td>
                                        <td>
                                            <button onClick={() => toggleActive(index)} className="toggle-btn">
                                                <i className={`fa ${update.active ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                            </button>
                                        </td>
                                        <td>
                                            <button onClick={() => setIsModalOpen(true)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button onClick={() => handleDelete(index)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        No updates found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <UpdateModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default Updates;
